import { RootState } from "../reducers"

export const selectFullLeaderboard = (state: RootState) =>
  state.leaderboard.fullLeaderboard.leaderboard

export const selectLeaderboardRankedUsers = (state: RootState) =>
  state.leaderboard.fullLeaderboard.users

export const selectUserLeaderboardRank = (state: RootState) =>
  state.leaderboard.currentUser

export const selectIsLeaderboardFullyFetched = (state: RootState) =>
  state.leaderboard.isFullyFetched
